import React from 'react'
import { ChronoBoard } from '../chrono/chronoBoard';
import { Chrono } from '../member/chrono';
import { Container, Tabs, Title, Flex, Stack,Text,UnstyledButton,Card, useMantineTheme, Modal } from '@mantine/core';
import {Link, Route,Routes} from "react-router-dom";
import { useDisclosure } from '@mantine/hooks';
import  ChronoPage  from "../chrono/Chrono";
import ChronoEdit from '../chrono/ChronoEdit';
import { IconPlus } from '@tabler/icons-react';





export default function SuiviPage() {
    return (
    <>
        <Title order={1} ta={"center"} m={"xl"}></Title>
        <Routes>
            <Route exact path="" element={<MainPage />} />
            <Route path=":suivi" element={<IndividualPage />} />
        </Routes>
    </>
    )
}


function MainPage(){
    const theme = useMantineTheme();
    const [opened, handlers] = useDisclosure(false);

    return(
        <>
        <Modal
            opened={opened}
            onClose={() => handlers.close()}
            size="80%"
            radius={"lg"}
            withCloseButton={false}
        >
        <Chrono onSubmit={handlers.close}/>
        </Modal>
        <Container size="xl" >
            <Card withBorder>
                <Card.Section p={"md"} bg={theme.colors.blue}>
                    <Title color='white' ta={"center"}>Liste des suivis</Title>
                </Card.Section>
                <Card.Section mx={"lg"} my={"md"}>
                    <Flex gap={'md'}>
                        <UnstyledButton bg={"white"} onClick={()=>handlers.toggle()}>
                            <Stack align='center' justify='center'>
                                <IconPlus color='green' size={32} />
                                <Text size="xs" color="green">
                                    Ajouter un Suivi
                                </Text>
                            </Stack>
                        </UnstyledButton>
                    </Flex>
                </Card.Section>
            </Card>
            <Tabs defaultValue={"all"}>
                <Tabs.List grow>
                    <Tabs.Tab value='all'>
                        Tous les suivis
                    </Tabs.Tab>
                    <Tabs.Tab value="active">
                        Suivi en attente
                    </Tabs.Tab>
                    <Tabs.Tab value='memberless'>
                        Suivi non-membre
                    </Tabs.Tab>
                </Tabs.List>
                <Tabs.Panel value='all'>
                <ChronoBoard range={"all"} />
                </Tabs.Panel>
                <Tabs.Panel value='active'>
                <ChronoBoard range={"active"} />
                </Tabs.Panel>
                <Tabs.Panel value="memberless">
                <ChronoBoard range={"memberless"} />
                </Tabs.Panel>
            </Tabs>

        </Container>
        </>
        )
}
function IndividualPage(){
    return(
    <Container size="xl">
        <Tabs defaultValue={"chrono"}>
            <Tabs.List>
                <Tabs.Tab value='chrono'>
                    Suivi
                </Tabs.Tab>
                <Tabs.Tab value="edit">
                    Modifier
                </Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value='chrono'>
                <ChronoPage/>
            </Tabs.Panel>
            <Tabs.Panel value='edit'>
                <ChronoEdit/>
            </Tabs.Panel>
        </Tabs>

    </Container>
    )
}
function NonMemberPage(){
    return(
    <Container>
        <ChronoBoard range={"memberless"}/>
    </Container>
    )
}